/**
 * Simple prompt dialog for text input
 */

import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import PropTypes from "prop-types";

const PromptDialog = ({
  visible,
  onHide,
  onConfirm,
  title,
  message,
  defaultValue = "",
  placeholder = "",
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (visible) {
      setValue(defaultValue);
    }
  }, [visible, defaultValue]);

  const handleConfirm = () => {
    if (value && value.trim()) {
      onConfirm(value.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    }
  };

  const footer = (
    <div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        onClick={onHide}
        className="p-button-text"
        data-evo-id="promptdialog-btn-cancel"
      />
      <Button
        label="OK"
        icon="pi pi-check"
        onClick={handleConfirm}
        disabled={!value || !value.trim()}
        data-evo-id="promptdialog-btn-ok"
      />
    </div>
  );

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: "min(450px, 92vw)" }}
      onHide={onHide}
      footer={footer}
      modal
    >
      <div className="p-fluid">
        {message && <p style={{ marginBottom: "1rem" }}>{message}</p>}
        <InputText
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          autoFocus
          data-evo-id="promptdialog-input-value"
        />
      </div>
    </Dialog>
  );
};

PromptDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
};

export default PromptDialog;
